(() => {
  // src/js/returns.js
  function autoResizeIframe() {
    let iframe = document.querySelector(".prose iframe");
    if (iframe) {
      window.addEventListener("message", (ev) => {
        if (ev.data.type && ev.data.type === "resize-iframe") {
          iframe.style.height = ev.data.payload.height + "px";
        }
      }, false);
    }
  }
  autoResizeIframe();
})();
